import useUniversalStore from "store/universalStore";
import { Loader } from "components";
const Collections = () => {
    const { user } = useUniversalStore();
    return user ?
        <iframe src={`https://app.sahukari.com/?sessionToken=${user?.getSessionToken()}&routeTo=emi`} width="100%" height="85%" />
        : <Loader />
}

export default Collections;